import axios from 'axios';

const baseURL = axios.create({baseURL : "https://e-commerce-server-ysor.onrender.com"})

export default baseURL

